import { render, staticRenderFns } from "./AtencionLabAs400.vue?vue&type=template&id=cd547250"
import script from "./AtencionLabAs400.vue?vue&type=script&lang=js"
export * from "./AtencionLabAs400.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports